;(function() {
    var
    
    _$wrapper = null,

    _report_id = null,

    //the popup showing the columns
    _$popup = null,

    //our json data for the columns
    _data = null,

    //set to true when a popup is open, can't open another
    _popup_open = false,
    

    //
    // init 
    //
    init = function() {
        _$wrapper = $('.layout-report');

        if (_$wrapper.length > 0) {
            //get the report id
            _report_id = _$wrapper.find('#hdnReportID').val();

            setupColumnsLink();
            setupCellClick();
            setupCloseControlsClick();
            setupNewRowClick();
            setupDeleteRow();
        }
    },


    //
    // setup the columns link to show the popup
    //
    setupColumnsLink = function() {
        _$wrapper.on('click', '.lnk-columns', function() {
            if (!_popup_open) {
                _popup_open = true;
                //get the json
                delta.ajax.get(
                    '/report/columns?reportID=' + _report_id,
                    function(json) {
                        //save the json
                        _data = json;

                        //open the popup
                        delta.popup.open({
                            type: 'confirm',
                            title: 'Report Columns',
                            content: '',
                            css: 'modal-xl popup-column-edit',
                            afterOpen: function($popup) {
                                _popup_open = false;

                                //save the popup
                                _$popup = $popup;

                                //render the table body
                                renderTable();

                                //setup the drag/drop for the table rows
                                setupDragDrop();
                            },
                            okCallback: function($popup) {
                                //hide the cotrols so the json it updated first
                                hideControls();

                                if (!validate()) {
                                    //invalid, show popup
                                    delta.popup.open({
                                        type: 'alert',
                                        title: 'Title Required',
                                        content: 'Title is required for all report columns.',
                                        okCallback: function() {
                                            //re-enable the buttons on the main popup
                                            delta.popup.enableButtons($popup);
                                        }
                                    });
                                } else {
                                    //save it
                                    delta.ajax.post(
                                        '/report/columns',
                                        _data,
                                        function(html) {
                                            //update the underlying page & close the popup
                                            _$wrapper.html(html);

                                            //setup the popovers
                                            delta.report.setupPopoverLines();
                                            
                                            delta.popup.close($popup);
                                        }
                                    );
                                }

                                //keep popup open
                                return false;
                            }
                        });
                    }
                );
            }

            return false;
        });
    },

    //
    // render the table
    //
    renderTable = function() {
        var s = '';

        s += '<div class="sortable">';

        for(var i=0; i<_data.columns.length; i++) {        
            var m = _data.columns[i];            
            s += '<div class="column-item draggable clearfix" data-index="' + i +'">';
            s += '<div class="icon handle float-start"><a href="#" class="handle"><i class="fas fa-grip-vertical fa-fw"></i></a></div>';
            s += '<table><tbody>';

            // Row 1
            s += '<tr class="captions">';
            s += '<td>Type</td>';
            s += '<td>Heading 1</td>';
            s += '<td>Text</td>';
            s += '<td>Variance</td>';
            s += '<td>Format $</td>';
            s += '</tr>';

            s += '<tr class="controls">';
            s += '<td data-prop="dataType">' + getEnum(_data.dataTypeOptions, m.dataType).display + '</td>';
            s += '<td data-prop="heading1">' + getEnum(_data.heading1Options, m.heading1).display + '</td>';
            s += '<td data-prop="heading1Custom">' + m.heading1Custom + '</td>';
            s += '<td data-prop="variance">' + getEnum(_data.varianceOptions, m.variance).display + '</td>';
            s += '<td data-prop="formatDollar">' + getEnum(_data.formatDollarOptions, m.formatDollar).display + '</td>';
            s += '</tr>';

            // Row 2
            s += '<tr class="captions">';
            s += '<td>Range</td>';
            s += '<td>Heading 2</td>';
            s += '<td>Text</td>';
            s += '<td>Variance Heading</td>';
            s += '<td>Format %</td>';
            s += '</tr>';

            s += '<tr class="controls">';
            s += '<td data-prop="dateRange">' + getEnum(_data.dateRangeOptions, m.dateRange).display + '</td>';
            s += '<td data-prop="heading2">' + getEnum(_data.heading2Options, m.heading2).display + '</td>';
            s += '<td data-prop="heading2Custom">' + m.heading2Custom + '</td>';
            s += '<td data-prop="varianceHeading">' + getEnum(_data.varianceHeadingOptions, m.varianceHeading).display + '</td>';
            s += '<td data-prop="formatPct">' + getEnum(_data.formatPctOptions, m.formatPct).display + '</td>';
            s += '</tr>';

            s += '</tbody></table>';

            s += '<div class="icon float-end"><a class="lnk-delete-row" href="#"><i class="fas fa-trash fa-fw"></i></a></div>';
            s += '</div>';
        }

        //closes sortable
        s += '</div>';

        //add + row
        s += '<div class="plus">';
        s += '<a href="#" class="lnk-new-row"><i class="fas fa-plus fa-fw"></i></a>';
        s += '</div>';
        
        _$popup.find('.modal-body').html(s);
    },


    //
    // return an item from one of the data enum lists.
    //
    getEnum = function(enumList, value) {
        for(var i=0; i<enumList.length; i++) {
            if (enumList[i].value == value) {
                return enumList[i];
            }
        }
    },

    //
    // finds an enum value based on it's display value
    //
    getEnumByDisplay = function(enumList, display) {
        for(var i=0; i<enumList.length; i++) {
            if (enumList[i].display == display) {
                return enumList[i];
            }
        }
    }

    //
    // setup click hanlder on the tds
    //
    setupCellClick = function() {
        $(document).on('click', '.popup-column-edit td', function() {
            var $td = $(this);

            if ($td.attr('data-prop')) {
                showControls($td.closest('.column-item'));

                //set focus to the control in this td
                $td.children('*')[0].focus();
            }
        });
    },

    // 
    // show the edit controls for the table row
    //
    showControls = function($divItem) {
        //if not editing
        if (!$divItem.attr('data-edit-mode')) {

            //add the edit mode attr
            $divItem.attr('data-edit-mode', 'true');

            //get the data index
            var idx = $divItem.attr('data-index');

            //get the object
            var m = _data.columns[idx];

            //show the controls in the row
            $divItem.find('table td').each(function() {
                var $td = $(this);
                var prop = $td.attr('data-prop');

                //only if we had a data-prop, want to skip the drag & delete columns
                if (prop) {
                    if (prop == 'heading1Custom' || prop == 'heading2Custom') {
                        //show text box
                        var $txt = $('<input type="text" class="form-control"/>');
                        $txt.val(_data.columns[idx][prop]);
                        $td.html($txt);
                    } else {
                        //show dropdown
                        var $cbo = $('<select class="form-select"></select>');
                        var enums = _data[prop + 'Options'];
                        for (var i=0; i<enums.length; i++) {
                            $cbo.append('<option value="' + enums[i].value + '">' + enums[i].display + '</option');
                        }
                        
                        $cbo.val(_data.columns[idx][prop]);
                        $td.html($cbo);
                    }
                }
            });
        }
    },

    //
    // hide the controls and update the json object
    //
    hideControls = function($divItemClicked) {
        //check each edit row
        _$popup.find('.modal-body .column-item[data-edit-mode="true"]').each(function() {
            var $divItem = $(this);

            //if the click didn't occur on this row
            if ($divItemClicked == null || !$divItemClicked.is($divItem)) {
                //remove edit mode attribute
                $divItem.attr('data-edit-mode', '');

                //get the index
                var idx = $divItem.attr('data-index');

                $divItem.find('table td').each(function() {
                    var $td = $(this);
                    var prop = $td.attr('data-prop');

                    //only if we have a data-prop, skip the drag & delete columns
                    if (prop) {
                        if (prop == 'heading1Custom') {
                            //update the json object
                            _data.columns[idx].heading1Custom = $td.find('input').val();

                            //update the td
                            $td.html(_data.columns[idx].heading1Custom);
                        } else if (prop == 'heading2Custom') {
                            //update the json object
                            _data.columns[idx].heading2Custom = $td.find('input').val();

                            //update the td
                            $td.html(_data.columns[idx].heading2Custom);
                        } else {
                            //update the json object
                            var val = parseInt($td.find('select').val());

                            _data.columns[idx][prop] = val;

                            //update the td
                            $td.html(getEnum(_data[prop + 'Options'], _data.columns[idx][prop]).display);
                        }
                    }
                });
            }
        });

        // console.log(_data);
    },

    //
    // handle onblur to turn off controls
    //
    setupCloseControlsClick = function() {
        $(document).on('click', '.popup-column-edit', function() {
            //get the elem with focus, this will only return an object if we clicked on another row
            //which set focus to it's control
            var $focus = $(':focus');

            if ($focus.length == 0) {
                hideControls(null);
            } else {
                //get the parent colum-edit item
                var $divItem = $focus.closest('.column-item');
                // hideControls($tr);
                hideControls($divItem);
            }
        });
    },

    //
    // setup the drag/drop for the table rows
    //
        setupDragDrop = function () {

        _$popup.find('.modal-body .sortable').sortable({
            handle: '.handle',
            // axis: 'y',
            start: function() {
                hideControls(null);
            },
            stop: function() {
                rebuildColumnsJson();
                setupDragDrop();
            }
        });

    },

    //
    // rebuild the _data.columns based on the current table order (used after drag/drop)
    //
    rebuildColumnsJson = function() {
        var idx = 0;

        var ar = [];
        
        _$popup.find('.modal-body .column-item').each(function() {
            var $divItem = $(this);

            //if it's a control row
            if ($divItem.attr('data-index')){
                //update the index on the row
                $divItem.attr('data-index', idx);

                var m = new Object();

                $divItem.find('td').each(function() {
                    var $td = $(this);
                    var prop = $td.attr('data-prop');

                    
                    if (prop) {
                        if (prop == 'heading1Custom' || prop == 'heading2Custom') {                            
                            m[prop] = $td.html();
                        } else {
                            m[prop] = getEnumByDisplay(_data[prop + 'Options'], $td.html()).value;
                        }
                    }

                });

                //add the object to the array
                ar.push(m);

                //increment the index
                idx++;
            }
        });

        //set variance & variance heading for first column to defaults
        if (ar.length > 0) {
            ar[0].variance = 0;
            ar[0].varianceHeading = 0;
        }

        //update the module level data
        _data.columns = ar;

        //rewrite table
        renderTable();
    },


    //
    // New Row (+ on last row in table)
    //
    setupNewRowClick = function() {
        $(document).on('click', '.popup-column-edit .lnk-new-row', function() {
            //first, close any edit rows
            hideControls(null);

            //create the new json object
            var m = new Object();

            m.dataType = 0;
            m.heading1 = 0;
            m.heading1Custom = '';
            m.variance = 0;
            m.formatDollar = 0;

            m.dateRange = 0;
            m.heading2 = 0;
            m.heading2Custom = '';
            m.varianceHeading = 0;
            m.formatPct = 0;

            _data.columns.push(m);

            //re-render the table
            renderTable();

            //click on the Title td of the new row to show the controls and set focus
            var $divItem = _$popup.find('.modal-body .column-item:last tr.controls:first');            

            $divItem.find('td').eq(1).click();

            setupDragDrop();

            return false;
        });
    },

    //
    // Delete row
    //
    setupDeleteRow = function() {
        $(document).on('click', '.popup-column-edit .lnk-delete-row', function() {
            //first, close any edit rows
            hideControls(null);

            // get the index
            var idx = $(this).closest('.column-item').attr('data-index');
            
            //create the content
            var s = 'Are you sure you want to delete this column?';
            
            //open the popup
            delta.popup.open({
                type: 'confirm',
                title: 'Delete Column',
                content: s,
                okCallback: function() {
                    //remove it
                    _data.columns.splice(idx, 1);

                    //re-render the table
                    renderTable();

                    setupDragDrop();
                }
            });

            return false;
        });
    },


    //
    // validate the fields
    //
    validate = function() {
        //TODO: add for custom text 1 & 2??
        // for (var i=0; i<_data.columns.length; i++) {
        //     if (!_data.columns[i].title) {
        //         return false;
        //     }
        // }

        //it's valid if we make it here.
        return true;
    },

    dummy = function(){};

    $(document).ready(init);
})();




